import React from 'react';
import { Link, useLocation } from 'react-router-dom';
type SectionLinkProps = {
  hash: string;
  className?: string;
  onClick?: () => void;
  children: React.ReactNode;
};

/**
 * Links to an on-page section (#services, #contact, ...).
 * On the homepage it stays a plain anchor so smooth scrolling works;
 * from a neighborhood page it routes home and lets ScrollToHash finish the job.
 */
export function SectionLink({
  hash,
  className,
  onClick,
  children
}: SectionLinkProps) {
  const {
    pathname
  } = useLocation();
  if (pathname === '/') {
    return <a href={hash} className={className} onClick={onClick} data-id="element-192" data-mp="pbx04efla7as">
        {children}
      </a>;
  }
  return <Link to={`/${hash}`} className={className} onClick={onClick} data-id="element-193" data-mp="fk937y09jy1x">
      {children}
    </Link>;
}